"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENCY_SIGN = void 0;
var CURRENCY_SIGN = {
  AED: "\u062F.\u0625",
  INR: "\u20B9",
  USD: "$",
  JPY: "\xA5",
  BDT: "\u09F3",
  CAD: "$",
  CHF: "CHF",
  CNY: "\xA5",
  DKK: "kr",
  EUR: "\u20AC",
  GBP: "\xA3",
  HKD: "HK$",
  KES: "KSh",
  KRW: "\u20A9",
  LKR: 'LKR',
  MUR: "\u20A8",
  MYR: "RM",
  NOK: "kr",
  NPR: 'NPR',
  NZD: "NZ$",
  OMR: "\uFDFC",
  PHP: "\u20B1",
  QAR: "\uFDFC",
  SAR: "\uFDFC",
  SEK: "kr",
  SGD: "S$",
  AUD: "AU$",
  THB: "\u0E3F",
  ZAR: "R"
};
exports.CURRENCY_SIGN = CURRENCY_SIGN;